import { BottomSheet } from '@common/ui/BottomSheet';
import { Button } from '@common/ui/buttons/Button';

import { type CurrentBillingSubscription } from '@services/PaymentsService';

import { formatDate, formatPaymentMethod } from '../../utils';

export interface CancelSubscriptionDialogProps {
  subscription: CurrentBillingSubscription;
  loading?: boolean;
  onConfirm: () => void;
  onKeep: () => void;
}

export const CancelSubscriptionDialog = ({
  subscription,
  loading,
  onConfirm,
  onKeep,
}: CancelSubscriptionDialogProps) => {
  const expiresAt = formatDate(subscription.expiresAt);
  const paymentMethod = formatPaymentMethod(subscription.paymentMethod);

  return (
    <BottomSheet
      image="/icons/3d-icons/sad.png"
      title="Отменить подписку?"
      subtitle={
        expiresAt
          ? `После отмены доступ сохранится до ${expiresAt}`
          : 'После отмены подписка не будет продлеваться'
      }
      buttons={[
        <Button
          testId="cancel-subscription-confirm-button"
          variant="negativeSecondary"
          loading={loading}
          onClick={onConfirm}
        >
          Отменить подписку
        </Button>,
        <Button
          testId="cancel-subscription-keep-button"
          variant="actionSecondary"
          disabled={loading}
          onClick={onKeep}
        >
          Оставить подписку
        </Button>,
      ]}
      data-test-id="cancel-subscription-dialog"
    >
      {paymentMethod && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gridGap: 8,
            padding: '16px 32px 0',
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: 0.2,
          }}
          data-test-id="cancel-subscription-payment-method"
        >
          <span style={{ color: 'var(--text-secondary-transparent)' }}>
            Способ оплаты
          </span>
          <span>{paymentMethod}</span>
        </div>
      )}
    </BottomSheet>
  );
};
